import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router";
import GetLocalStorage from "./GetLocalStorage";
import { useLocation } from "react-router-dom";

const useAuth = () => {
  const user = JSON.parse(localStorage.getItem("user_profile"));

  if (user !== null) {
    return user;
  }
};

const ProtectedRoutes = () => {
  const isAuth = useAuth();
  const onboardingStatus = GetLocalStorage("onboardingStatus");
  const location = useLocation();

  // Allow access to /kyc-verification route even if onboarding is not completed
  if (
    isAuth &&
    onboardingStatus !== "COMPLETED" &&
    !location.pathname.startsWith("/kyc-verification")
  ) {
    return (
      <Navigate to={`/kyc-verification?onboardingStatus=${onboardingStatus}`} />
    );
  }

  return isAuth ? <Outlet /> : <Navigate to={"/"} />;
};

const LoggedInRoute = () => {
  const isAuth = useAuth();
  return !isAuth ? <Outlet /> : <Navigate to={"/dashboard"} />;
};

export { ProtectedRoutes, LoggedInRoute };
